<pmd-navbar class="d-flex align-items-center">
	<pmd-navbar-brand>
		<a href="#" class="navbar-brand p-0 d-block">
			<img src="assets/images/kanz-logo.png" class="fils-logo" alt="PayKanz" height="48">
		</a>
	</pmd-navbar-brand>
	<pmd-navbar-right-icon class="ms-auto">
		<div class="navbar-action-nav align-items-center d-flex gap-2 gap-lg-0">
			<!-- <div class="d-flex align-items-center pf-btn-wrapper">
				<a href="#" type="button" class="d-flex align-items-center">
					<button type="button" class="me-0" pmdRipple pmd-btn-fab color="dark" pmd-btn-outline size="sm">
						<i class="material-icons-round pmd-icon-xs">download</i>
					</button>
					<span class="d-none d-md-block">Download Summary</span>
				</a>
			</div> -->
			<div class="d-flex align-items-center pf-btn-wrapper me-md-0 me-2 noprint">
				<a (click)="print()" type="button" class="d-flex align-items-center">
					<button type="button" class="me-0" pmdRipple pmd-btn-fab color="dark" pmd-btn-outline size="sm">
						<i class="material-icons-round pmd-icon-xs">print</i>
					</button>
					<span class="d-none d-md-block border-end-0 pe-0 me-0">Print Summary</span>
				</a>
			</div>
		</div>
	</pmd-navbar-right-icon>
</pmd-navbar>